export enum CardTypes{
    Unsupported = -1,
    Unknown =0,
    Visa = 1,
    MasterCard = 2,
    Discover = 3,
    AmericanExpress = 4,
    MilitaryStarCard = 10,
    DinersClub = 5,
    NEACreditCard = 14,
    SearsGiftCard = 97,
    Sears = 98,
}


// WEBPACK FOOTER //
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/models/card-types.enum.ts